export default [
    {
        id: 'index',
        name: '首页',
        code: 'index',
        iconSkin: "icon-index-copy"
    },
    {
        id: 'operate',
        name: '充值领卡管理',
        code: 'operate',
        iconSkin: "icon-yunying",
        children: [
            {
                id: 'cardGrant',
                name: '制卡记录',
                code: 'cardGrant',
                iconSkin: 'icon-yonghuguanli'
            },
            {
                id: 'cardApplys',
                name: '领卡申请',
                code: 'cardApplys',
                iconSkin: 'icon-yonghuguanli'
            },
            {
                id: 'cardAudit',
                name: '领卡审批',
                code: 'cardAudit',
                iconSkin: 'icon-yonghuguanli'
            },
            {
                id: 'batchFill',
                name: '员工餐卡批量充值',
                code: 'batchFill',
                iconSkin: 'icon-yonghuguanli'
            },
            {
                id: 'fillAudit',
                name: '员工餐卡充值审批',
                code: 'fillAudit',
                iconSkin: 'icon-yonghuguanli'
            },

        ]
    },
    {
        id: 'card',
        name: '卡片管理',
        code: 'card',
        iconSkin: "icon-qiapian",
        children: [
            {
                id: 'cardOpen',
                name: '卡片开户',
                code: 'cardOpen',
                iconSkin: "icon-yonghuguanli",
            },
            {
                id: 'cardList',
                name: '已激活卡片列表',
                code: 'cardList',
                iconSkin: "icon-yonghuguanli",
            }
        ]
    },
    {
        id: 'customer',
        name: '客户管理',
        code: 'customer',
        iconSkin: 'icon-kehu',
        children: [
            {
                id: 'customerList',
                name: '客户列表',
                code: 'customerList',
                iconSkin: 'icon-yonghuguanli'
            },
            {
                id: 'customerBlackList',
                name: '黑名单列表',
                code: 'customerBlackList',
                iconSkin: 'icon-yonghuguanli'
            }
        ]
    },
    {
        id: 'trade',
        name: '交易管理',
        code: 'trade',
        iconSkin: 'icon-jiaoyi',
        children: [
            {
                id: 'dayDetail',
                name: '当日明细',
                code: 'dayDetail',
                iconSkin: 'icon-yonghuguanli'
            },
            {
                id: 'invoiceManage',
                name: '发票管理',
                code: 'invoiceManage',
                iconSkin: 'icon-yonghuguanli'
            },
            {
                id: 'historyDetail',
                name: '历史明细',
                code: 'historyDetail',
                iconSkin: 'icon-yonghuguanli'
            }
        ]
    },
    {
        id: 'finance',
        name: '财务管理',
        code: 'finance',
        iconSkin: 'icon-caiwu',
        children: [
            // {
            //     id: 'saleCardAudit',
            //     name: '售卡清算',
            //     code: 'saleCardAudit',
            //     iconSkin: 'icon-yonghuguanli'
            // },
            {
                id: 'rechargeAudit',
                name: '充值统计',
                code: 'rechargeAudit',
                iconSkin: 'icon-yonghuguanli'
            },
            {
                id: 'consumeAudit',
                name: '消费统计',
                code: 'consumeAudit',
                iconSkin: 'icon-yonghuguanli'
            },
            // {
            //     id: 'cancelAudit',
            //     name: '销户统计',
            //     code: 'cancelAudit',
            //     iconSkin: 'icon-yonghuguanli'
            // },
            // {
            //     id: 'verifyManage',
            //     name: '对账管理',
            //     code: 'verifyManage',
            //     iconSkin: 'icon-yonghuguanli'
            // },
            {
                id: 'merchantAudit',
                name: '商户清算',
                code: 'merchantAudit',
                iconSkin: 'icon-yonghuguanli'
            }
        ]
    },
    {
        id: 'system',
        name: '系统设置',
        code: 'system',
        iconSkin: 'icon-shezhi',
        children: [
            {
                id: 'organization',
                name: '组织机构',
                code: 'organization',
                iconSkin: 'icon-yonghuguanli'
            },
            {
                id: 'account',
                name: '账户管理',
                code: 'account',
                iconSkin: 'icon-yonghuguanli'
            },
            {
                id: 'role',
                name: '角色管理',
                code: 'role',
                iconSkin: 'icon-yonghuguanli'
            },
            {
                id: 'dict',
                name: '字典管理',
                code: 'dict',
                iconSkin: 'icon-yonghuguanli'
            },
            {
                id: 'deviceBind',
                name: '设备绑定',
                code: 'deviceBind',
                iconSkin: 'icon-yonghuguanli'
            },
            {
                id: 'log',
                name: '操作日志',
                code: 'log',
                iconSkin: 'icon-yonghuguanli'
            },
            {
                id: 'menu',
                name: '菜单管理',
                code: 'menu',
                iconSkin: 'icon-yonghuguanli'
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/sys/resource/navigate.js